import { isCheckPermission, LEAVE_ROOM, SET_ACTIVE_GROUP_ID } from '../../room';
import { hideNotification, showNotification } from '../notification/actions';
import { SHOW_NOTIFICATION } from '../notification/actionTypes';
import { getNotificationLimit, getNotificationList } from '../notification/functions';
import { MiddlewareRegistry } from '../redux';
import { removeAllMembers, responsePresentation, setBridgeId, setHandlerMember, setMemberPinned, setMemberRole, updateMember, } from './actions';
import { ADD_LOCAL_MEMBER, ADD_MEMBER, ADD_PINNED, ADD_RECORD, CHAT_DISABLED, CHAT_ENABLED, DELETE_MEMBER, DELETE_PINNED, DELETE_RECORD, HANDLER_LIVE_MEMBER, REQUEST_PRESENTER, RESPONSE_PRESENTER, SET_MEMBER_ROLE, UPDATE_MEMBER_NICKNAME, } from './actionType';
import { MEMBER_STATUS, PERMISSION, ROLE } from './constans';
import { checkRoleLevel, getLocalIDMember, getLocalMember, getLocalMemberRole, getMemberByUserID, getPinnedMembersBySeminar, getSpeakerId, } from './functions';
MiddlewareRegistry.register(store => next => async (action) => {
    const { getState, dispatch } = store;
    let member = undefined;
    let notification = true;
    switch (action.type) {
        case ADD_LOCAL_MEMBER:
        case ADD_MEMBER:
            member = action.member;
            if (!member)
                return;
            if (member.type === 'hidden')
                return null;
            if (member.jitsi_id) {
                dispatch(setBridgeId(member.user_uuid, member.jitsi_id));
            }
            break;
        case ADD_PINNED:
        case DELETE_PINNED:
            member = getMemberByUserID(getState, action.user_uuid);
            if (!member)
                return;
            if (getLocalIDMember(getState) === action.user_uuid) {
                if (action.pinned) {
                    APP.management.conferenceAddedTrack();
                    APP.management.conferenceAddedTrack("audio");
                } /* 손들기→라이브 시 카메라와 함께 마이크도 켠다(청취자면 즉석 획득) */
                else {
                    APP.management.conferenceRemovedTrack();
                    APP.management.conferenceRemovedTrack("audio");
                }
            }
            const seminarId = getSpeakerId(getState);
            if (member?.user_uuid === seminarId && member.role !== ROLE.HOST)
                return;
            if (!action.isRemote) {
                if (isCheckPermission(getState, PERMISSION.PIN)) {
                    const response = await APP.management.setMemberPinned(action.user_uuid, action.pinned);
                    if (response.status !== 200) {
                        console.log('error-setMemberPinned');
                        return;
                    }
                }
                else
                    return;
            }
            if (!member)
                return;
            dispatch(updateMember({
                ...member,
                pinned: action.pinned,
            }));
            break;
        case CHAT_DISABLED:
        case CHAT_ENABLED:
            member = getMemberByUserID(getState, action.user_uuid);
            if (!member)
                return;
            // if (member?.user_uuid === seminarId && member.role !== ROLE.HOST) return;
            if (!action.isRemote) {
                if (isCheckPermission(getState, PERMISSION.CHAT)) {
                    const response = await APP.management.setMemberChatDisabled(action.user_uuid, action.disabled);
                    if (response.status !== 200) {
                        console.log('error-setMemberChatDisabled');
                        return;
                    }
                }
                else
                    return;
            }
            if (!member)
                return;
            dispatch(updateMember({
                ...member,
                chat_disabled: action.disabled,
            }));
            break;
        case ADD_RECORD:
        case DELETE_RECORD:
            if (!action.isRemote) {
                if (isCheckPermission(getState, PERMISSION.PIN)) {
                    const response = await APP.management.setRecording(action.user_uuid, action.type === ADD_RECORD ? true : false);
                    if (response.status !== 200) {
                        console.log('error-setRecording');
                        return;
                    }
                }
                else
                    return;
            }
            member = getMemberByUserID(getState, action.user_uuid);
            if (!member)
                return;
            dispatch(updateMember({
                ...member,
                recording: action.record,
            }));
            break;
        case RESPONSE_PRESENTER:
            if (action.isRemote === false) {
                if (action.accepted) {
                    dispatch(setMemberRole(action.user_uuid, ROLE.PRESENTER, false));
                }
                const response = await APP.management.responsePresentation(action.user_uuid, action.accepted);
                if (response.status !== 200) {
                    /**
                     * (FIX Me)
                     */
                    return;
                }
            }
            else {
                const local_id = getLocalIDMember(getState);
                if (action.user_uuid === local_id) {
                    dispatch(showNotification({ titleKey: `notify.${action.accepted}ResponsePresenter` }));
                }
            }
            break;
        case SET_MEMBER_ROLE:
            member = getMemberByUserID(getState, action.user_uuid);
            if (!member)
                return;
            if (!action.isRemote) {
                if (isCheckPermission(getState, PERMISSION.MEMBER_ROLE)) {
                    const response = await APP.management.setMemberRole(action.user_uuid, action.role);
                    if (response.status !== 200) {
                        APP.UI.alertMessage('권한 설정이 올바르지않습니다. 새로고침 이후 다시 시도해주세요.');
                        return;
                    }
                }
                else
                    return;
            }
            dispatch(updateMember({
                ...member,
                role: action.role,
            }));
            break;
        case REQUEST_PRESENTER:
            const local_role = getLocalMemberRole(getState);
            if (action.isLocal) {
                const response = await APP.management.requestPresentation(action.member_uuid);
                if (response.status !== 200) {
                    /**
                     * (FIX Me)
                     */
                    return;
                }
            }
            else {
                if (checkRoleLevel(local_role, ROLE.HOST))
                    return;
            }
            break;
        case SHOW_NOTIFICATION:
            const limit = getNotificationLimit(getState);
            const show = getNotificationList(getState);
            if (show.size + 1 > limit) {
                const last = show.values().next().value;
                if (last) {
                    if (last?.presenter)
                        dispatch(responsePresentation(last?.uid, false, false));
                    else
                        dispatch(hideNotification(last?.id));
                }
            }
            break;
        case DELETE_MEMBER:
            member = action.member;
            if (!member)
                return;
            store.dispatch(updateMember({
                ...member,
                status: MEMBER_STATUS.VACATED,
            }));
            break;
        case SET_ACTIVE_GROUP_ID:
            member = getLocalMember(getState, false);
            if (!member)
                return;
            store.dispatch(updateMember({
                ...member,
                active_group: action.group_id,
            }));
            break;
        case UPDATE_MEMBER_NICKNAME:
            member = getMemberByUserID(getState, action.user_uuid);
            if (!member)
                return;
            if (!action.isRemote) {
                const response = await APP.management.updateNickname(action.nickname);
                if (response.status !== 200) {
                    console.log('error');
                    return;
                }
            }
            store.dispatch(updateMember({
                ...member,
                nickname: action.nickname,
            }));
            break;
        case HANDLER_LIVE_MEMBER:
            const pinIds = getPinnedMembersBySeminar(getState);
            // ★기존 라이브 멤버를 "완전히" 내린 뒤 새 멤버를 올린다(순서 보장).
            // 기존 [...pinIds].map(async …) 는 await 되지 않아, 이전 라이브 학생 해제
            // (서버 raiseHand 왕복 포함)가 끝나기 전에 새 학생 핀이 진행돼 두 화면이 동시에
            // 켜지는 레이스가 있었다. for…of + await 로 해제를 먼저 끝내고 핀을 건다.
            //
            // ★수락(라이브 승격, isLive=true) 시에만 기존 라이브 멤버를 해제한다.
            // 거절(X, isLive=false)은 대상의 손만 내려야 하며, 이미 라이브 중인 다른 학생을
            // 건드리면 안 된다. 조건이 없던 기존 코드는 거절 시에도 이 루프가 돌아
            // 라이브 중이던 학생까지 함께 내려가는 버그가 있었다.
            if (action.isLive && pinIds && pinIds.length > 0) {
                for (const m of pinIds) {
                    if (m === action.user_uuid)
                        continue; // 새로 올릴 멤버는 제외
                    // @ts-ignore
                    await dispatch(setHandlerMember(m, false, false));
                    await dispatch(setMemberPinned(m, false));
                }
            }
            await dispatch(setMemberPinned(action.user_uuid, action.isLive));
            // @ts-ignore
            await dispatch(setHandlerMember(action.user_uuid, action.isLive, false));
            break;
        case LEAVE_ROOM:
            dispatch(removeAllMembers());
            break;
    }
    return next(action);
});
